import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import consumer from "./cable";
import { selectBillableAccount } from "../features/billableAccounts/billableAccountsSlice";

export const useAccountAlerts = (onReceived) => {
  const subscriptionsRef = useRef({});

  const account = useSelector(selectBillableAccount);
  const connectionId = account.id

  useEffect(() => {
    if (!connectionId) return;

    Object.values(subscriptionsRef.current).forEach((sub) => sub.unsubscribe());
    subscriptionsRef.current = {};

    const subscription = consumer.subscriptions.create(
      {
        channel: "BillableAccountNotesAlertConnectionChannel",
        connection_id: connectionId,
      },
      {
        received: (data) => {
          if (onReceived) onReceived(connectionId, data);
        },
      }
    );

    subscriptionsRef.current[connectionId] = subscription;

    return () => {
      subscription.unsubscribe();
      subscriptionsRef.current = {};
    };
  }, [connectionId, onReceived]);

  return connectionId;
};
